// Copyright ©️ 2026 eVolve MEP, LLC

import { type ReactNode, useState } from 'react';

type Props = {
  /** Render prop that receives the current search string and returns the panel's list content. */
  children: (search: string) => ReactNode;
};

/**
 * Shared layout wrapper for viewer docking panel selectors.
 *
 * Provides a search input and a scrollable list container.
 * Does not use Mantine components - This is for legacy components where the Mantine theme was not available.
 *
 * TODO: Update this to use Mantine or potentially remove it if not needed anymore.
 */
export const SelectorPanel = ({ children }: Props) => {
  const [search, setSearch] = useState('');

  return (
    <div
      style={{
        marginTop: 2,
        marginBottom: 21,
        colorScheme: 'dark',
      }}
    >
      <div style={{ padding: 5, paddingLeft: 7, paddingRight: 7, display: 'flex' }}>
        <input
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value)}
          style={{ flex: 1, padding: 2, paddingLeft: 7, borderRadius: 4 }}
        />
      </div>
      <div
        // Built-in Forge Viewer class
        className="docking-panel-scroll"
        style={{
          minWidth: 220,
          maxHeight: 280,
          overflowY: 'auto',
          scrollbarColor: 'auto',
        }}
      >
        {children(search)}
      </div>
    </div>
  );
};
